import React, { PureComponent } from 'react';
import Lozenge from '@atlaskit/lozenge';
import RelativeDate from '../../components/RelativeDate';
import { STORY_BASE_URL } from '../../config';

export default class ComponentDetailBody extends PureComponent {
  render() {
    const { data } = this.props;
    if (!data) return null;

    const {
      componentName,
      componentVersion,
    } = this.props;
    const componentTag = `@atlaskit/${componentName}@${componentVersion}`;
    let team = 'AtlasKit';
    if (data.pkgJsonInfo.keywords.indexOf('fabric') > -1) {
      team = 'Fabric';
    } else if (data.pkgJsonInfo.keywords.indexOf('media') > -1) {
      team = 'Media';
    }

    return (
      <div>
        <h3>Component info</h3>
        <div className="row">
          <div className="col-5">
            <dl>
              <dt>Install</dt>
              <dd>
                <code>yarn add {componentTag}</code>
              </dd>
              <dt>Documentation</dt>
              <dd>
                <a href={`https://www.npmjs.com/package/@atlaskit/${componentName}`}>Docs on NPM</a>
              </dd>
              <dt>Source code</dt>
              <dd>
                <a href={`https://bitbucket.org/atlassian/atlaskit/src/master/packages/${componentName}`}>Bitbucket</a>
              </dd>
            </dl>
          </div>


          <div className="col-5">
            <dl>
              <dt>This version</dt>
              <dd>
                <a href={`https://npmjs.com/package/@atlaskit/${componentName}`}>{data.version}</a>
                {
                  data.npmInfo.isPublished ? (
                    <span style={{ paddingLeft: 4 }}>
                      (<RelativeDate iso={data.npmInfo.publishTime} />)
                      <Lozenge appearance="success">Published</Lozenge>
                    </span>
                  ) : null
                }
              </dd>
              <dt>Bundle</dt>
              <dd>
                <a href={`https://unpkg.com/${componentTag}/dist/`}>unpkg dist</a>
              </dd>
              <dt>Team</dt>
              <dd><Lozenge appearance="new">{team}</Lozenge></dd>
            </dl>

          </div>
        </div>
        <h3 style={{ paddingTop: '80px' }}>
          Storybook (<a href={`${STORY_BASE_URL}/@atlaskit/${componentName}/${data.version}/`} target="_blank" rel="noreferrer noopener">this version</a>)
        </h3>
        <p>
          <iframe
            style={{ width: '100%', minHeight: '600px', border: '1px solid #DDD' }}
            src={`${STORY_BASE_URL}/@atlaskit/${componentName}/${data.version}/`}
          />
        </p>

        <h3 id="release-notes" style={{ paddingTop: 80 }}>
          Release notes (<a href={`https://unpkg.com/@atlaskit/${componentName}@${data.version}/CHANGELOG.md`} target="_blank" rel="noreferrer noopener">raw markdown</a>)
        </h3>
        <p>
          <iframe
            style={{ width: '100%', minHeight: '600px', border: '1px solid #DDD' }}
            src={`https://markdown-renderer-27442.firebaseapp.com/?url=https://unpkg.com/${componentTag}/CHANGELOG.md&stylesheet=TODO/css/main.css?t=TODO`}
          />
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ComponentDetailPage/ComponentDetailBody.jsx